import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UtilitiesService } from 'src/app/core/services/utilities.service';
import * as moment from 'moment';
import { HuespedesComponent } from '../inputs/huespedes/huespedes.component';
import { DatepickerComponent } from '../inputs/datepicker/datepicker.component';
import { saveDataSearchUtil } from 'src/app/core/services/utilities/saveDataSearchUtil.service';

@Component({
  selector: 'app-hotels',
  templateUrl: './hotels.component.html',
  styleUrls: ['./hotels.component.scss']
})
export class HotelsComponent implements OnInit {
  @Input() public widgetData: any = null;
  @ViewChild('picker1') datePicker: DatepickerComponent;
  @ViewChild('picker2') datePicker2: DatepickerComponent;
  @ViewChild('huespedes1') huspedes: HuespedesComponent;
  @ViewChild('huespedes2') huspedes2: HuespedesComponent;
  public form: FormGroup;
  public submit: boolean;
  private apiBaseUrl = `https://hospedaje.mundojoven.com/search.do?`;

  constructor(
    private formB: FormBuilder,
    private _util: UtilitiesService,
    private saveInfoServ: saveDataSearchUtil
  ) {
    this.buildForm();
  }

  ngOnInit() {
  }
  buildForm() {
    this.form = this.formB.group({
      destino: ['', [Validators.required]],
      fecha: ['', [Validators.required]],
      habitaciones: ['', [Validators.required]]
    });

    this.form.get('destino').valueChanges.subscribe(value => {
      if (typeof value == 'object') {
        this.saveInfoSearchHT('destino', value.name + ' (' + value.iata + ')');
        // this.saveInfoSearchHT('destino', value);
        if (document.documentElement.clientWidth < 992) {
          this.datePicker2.openDatepicker();
        } else {
          this.datePicker.openDatepicker();
        }
      }
    });
    this.form.get('fecha').valueChanges.subscribe(value => {
      if (value.length == 2) {
        console.log('Entra dates', value);
        this.saveInfoSearchHT('fecha_ida', value[0]);
        this.saveInfoSearchHT('fecha_vuelta', value[1]);
        setTimeout(() => {
          if (document.documentElement.clientWidth < 992) {
            this.huspedes2.menu.openMenu();
          } else {
            this.huspedes.menu.openMenu();
          }
        }, 1000);
      }
    });
  }

  buscar() {
    this.submit = true;
    if (this.form.valid && typeof this.form.get('destino').value == 'object') {
      this.saveInfoSearchHT('habitaciones', JSON.stringify(this.form.value.habitaciones));
      let params = {
        'destination-id': this.form.get('destino').value.destinationId,
        'q-check-in': moment(this.form.get('fecha').value[0], 'DD-MM-YYYY').format('YYYY-MM-DD'),
        'q-check-out': moment(this.form.get('fecha').value[1], 'DD-MM-YYYY').format('YYYY-MM-DD'),
        'q-rooms': this.form.get('habitaciones').value.fHab.length
        // 'q-destination': '',
      };
      let rooms = {};
      this.form.get('habitaciones').value.fHab.forEach((room, i) => {
        rooms[`q-room-${i}-adults`] = room.fAdults;
        rooms[`q-room-${i}-children`] = room.fChilds;
        room.fEdades.forEach((childAges, childIndex) => {
          rooms[`q-room-${i}-child-${childIndex}-age`] = childAges.fEdad
        });
      });
      params = {
        ...params,
        ...rooms
      };
      console.log('URL', this._util.buildUrlWithParams(this.apiBaseUrl, params))
      window.location.href = this._util.buildUrlWithParams(this.apiBaseUrl, params);
    }
  }

  saveInfoSearchHT(key, value) {
    this.saveInfoServ.saveData('Widget hoteles', key, value);
  }

  updateForm(value) {
    this.form.get('habitaciones').setValue(value);
  }
}
